import { render, staticRenderFns } from "./CveVulnerabilities.vue?vue&type=template&id=33207e29&scoped=true&"
import script from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./CveVulnerabilities.vue?vue&type=script&lang=js&"
import style0 from "./CveVulnerabilities.vue?vue&type=style&index=0&id=33207e29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33207e29",
  null
  
)

export default component.exports